import React from 'react';
import { Row, Col, Space } from 'antd';
import TitleSection from './TitleSection';
import ContentRenderer from './ContentRenderer';
import '../css/PresentationTab.css';

function RealmObjectViewer({ realmObject, accessDenied }) {
  const hasImages = Boolean(realmObject?.payload?.images?.length);
  const realmObjectID = realmObject?.RealmObjectID;
  const layout = realmObject?.payload?.layout || 'full';
  const imagePosition = realmObject?.payload?.imagePosition || 'left';

  return (
    <Row className="realm-object-viewer">
      <Col xs={24}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <TitleSection {...{ realmObject, accessDenied }} />
          <ContentRenderer
            {...{ layout, imagePosition, hasImages, realmObjectID, realmObject }}
          />
        </Space>
      </Col>
    </Row>
  );
}

export default RealmObjectViewer;
